/**
 * A class contains information about special working time.
 */
import { StoreWorkingTime } from './StoreWorkingTime';

export class StoreSpecialWorkingTime {
  startDate: string;
  workingTime: StoreWorkingTime;

  /**
   * @param startDate the Monday starting from which store special working time takes effect.
   * @param workingTime special time when store opens and closes.
   */
  constructor(startDate: string, workingTime: StoreWorkingTime) {
    this.startDate = startDate;
    this.workingTime = workingTime;
  }
}
